<div (click)="openSearch()"
     class="search-collapse"
     [ngClass]="{'disable-button': isEditing}">
  <div class="search-collapse__box verticalAlign-content">
    <span class="icon-search"></span>
  </div>
</div>
